// import React from "react";

// const Zebra = () => {
//   return (
//     <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
//       <div className="text-sm text-gray-600 mb-4">
//         <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp; <span className="underline">Hizmetler</span> &nbsp;&gt;&nbsp; Stor Zebra Perde Yıkama
//       </div>

//       <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">İstanbul STOR & ZEBRA PERDE YIKAMA HİZMETİ</h1>

//       <div className="space-y-6">
//         <p>
//           İstanbul Temizlik Servisi olarak, stor ve zebra perdelerinizin temizliğini en hassas yöntemlerle gerçekleştiriyoruz. İstanbul genelinde sunduğumuz bu hizmetle perdelerinize zarar vermeden ilk günkü temizliğine kavuşturuyoruz.
//         </p>

//         <p>
//           Stor ve zebra perdeler, hassas mekanizmaları ve kumaş yapıları nedeniyle evde yıkanması riskli ürünlerdir. Uygun tekniklerle yıkanmadığında deforme olabilir, mekanizması bozulabilir ya da kumaş rengi solabilir. Biz, bu özel perdeler için profesyonel bir temizlik süreci uyguluyoruz.
//         </p>

//         <p>
//           Perdelerinizi adresinizden alıyor, özel perde yıkama makinelerinde dikkatli şekilde temizliyor ve kurutma sonrası zarar görmeden, düzgün şekilde teslim ediyoruz. Tüm süreç boyunca kalite kontrol uygulanır.
//         </p>

//         <p>
//           Perde yıkama işleminde kullandığımız deterjanlar ve solüsyonlar, stor ve zebra kumaşlarına zarar vermez. Ayrıca bakteri, toz ve kötü kokulardan tamamen arındırır.
//         </p>

//         <p>
//           Perde yıkama işlemleriniz için 7/24 Whatsapp ve telefon hatlarımızdan ulaşarak hızlı randevu oluşturabilirsiniz. Ücretsiz servisimiz ile hizmeti kapınıza getiriyoruz.
//         </p>

//         <h2 className="text-xl font-bold text-[#003132]">🪟 Profesyonel Stor & Zebra Perde Yıkama</h2>
//         <p>
//           Stor ve zebra perdeleriniz zamanla toz, sigara dumanı ve dış etkenlerle kirlenebilir. Firmamız, bu perdelerin kumaşına ve mekanizmasına özel temizlik uygulayarak maksimum hijyen sağlar.
//         </p>

//         <h2 className="text-xl font-bold text-[#003132]">💧 Perde Yıkama Sürecimiz</h2>
//         <ol className="list-decimal list-inside space-y-2">
//           <li>Perdelerin yerinden dikkatlice sökülmesi</li>
//           <li>Toz alma ve ön temizleme</li>
//           <li>Kumaş türüne göre özel solüsyon uygulaması</li>
//           <li>Yumuşak sistemle yıkama ve durulama</li>
//           <li>Doğal kurutma ve ütüleme</li>
//           <li>Tekrar montaj öncesi kalite kontrol</li>
//           <li>Adresinize teslimat ve/veya montaj</li>
//         </ol>

//         <h2 className="text-xl font-bold text-[#003132]">🧴 Kullandığımız Ürünler</h2>
//         <ul className="list-disc list-inside">
//           <li>Perde kumaşına uygun özel solüsyonlar</li>
//           <li>Renk solmasını önleyen doğal içerikli deterjanlar</li>
//           <li>Antibakteriyel temizlik ürünleri</li>
//         </ul>

//         <h2 className="text-xl font-bold text-[#003132]">✅ Neden Bizi Tercih Etmelisiniz?</h2>
//         <ul className="list-disc list-inside">
//           <li>Perdeye zarar vermeyen özel yıkama teknikleri</li>
//           <li>Ücretsiz alım ve teslimat hizmeti</li>
//           <li>Zebra ve stor perdeye özel temizlik garantisi</li>
//           <li>Uygun fiyat – kaliteli hizmet dengesi</li>
//           <li>Tecrübeli ekip ve müşteri odaklı yaklaşım</li>
//         </ul>

//         <p>
//           Stor ve zebra perdelerinizin ömrünü uzatmak, ilk günkü temizliğine kavuşmasını sağlamak için bize ulaşın. Hijyenik, güvenilir ve profesyonel hizmeti kapınıza kadar getiriyoruz.
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Zebra;
import React from "react";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const Zebra = () => {
  return (
    <>
      <div className="max-w-7xl mx-auto py-6 px-4 grid grid-cols-1 lg:grid-cols-4 gap-8">
        {/* Sol Sidebar - sadece masaüstü için */}
        <div className="hidden lg:block">
          <LeftSidebar />
        </div>

        {/* Ana içerik */}
        <main className="lg:col-span-2">
          <div className="text-sm text-gray-600 mb-4">
            <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp; 
            <span className="underline">Hizmetler</span> &nbsp;&gt;&nbsp; Stor Zebra Perde Yıkama
          </div>

          <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">
            İstanbul STOR & ZEBRA PERDE YIKAMA HİZMETİ
          </h1>

          <div className="space-y-6 text-gray-800 leading-relaxed">
            <p>
              İstanbul Temizlik Servisi olarak, stor ve zebra perdelerinizin temizliğini en hassas yöntemlerle gerçekleştiriyoruz. İstanbul genelinde sunduğumuz bu hizmetle perdelerinize zarar vermeden ilk günkü temizliğine kavuşturuyoruz.
            </p>

            <p>
              Stor ve zebra perdeler, hassas mekanizmaları ve kumaş yapıları nedeniyle evde yıkanması riskli ürünlerdir. Uygun tekniklerle yıkanmadığında deforme olabilir, mekanizması bozulabilir ya da kumaş rengi solabilir. Biz, bu özel perdeler için profesyonel bir temizlik süreci uyguluyoruz.
            </p>

            <p>
              Perdelerinizi adresinizden alıyor, özel perde yıkama makinelerinde dikkatli şekilde temizliyor ve kurutma sonrası zarar görmeden, düzgün şekilde teslim ediyoruz. Tüm süreç boyunca kalite kontrol uygulanır.
            </p>

            <p>
              Perde yıkama işleminde kullandığımız deterjanlar ve solüsyonlar, stor ve zebra kumaşlarına zarar vermez. Ayrıca bakteri, toz ve kötü kokulardan tamamen arındırır.
            </p>

            <p>
              Perde yıkama işlemleriniz için 7/24 Whatsapp ve telefon hatlarımızdan ulaşarak hızlı randevu oluşturabilirsiniz. Ücretsiz servisimiz ile hizmeti kapınıza getiriyoruz.
            </p>

            <h2 className="text-xl font-bold text-[#003132]">🪟 Profesyonel Stor & Zebra Perde Yıkama</h2>
            <p>
              Stor ve zebra perdeleriniz zamanla toz, sigara dumanı ve dış etkenlerle kirlenebilir. Firmamız, bu perdelerin kumaşına ve mekanizmasına özel temizlik uygulayarak maksimum hijyen sağlar.
            </p>

            <h2 className="text-xl font-bold text-[#003132]">💧 Perde Yıkama Sürecimiz</h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>Perdelerin yerinden dikkatlice sökülmesi</li>
              <li>Toz alma ve ön temizleme</li>
              <li>Kumaş türüne göre özel solüsyon uygulaması</li>
              <li>Yumuşak sistemle yıkama ve durulama</li>
              <li>Doğal kurutma ve ütüleme</li>
              <li>Tekrar montaj öncesi kalite kontrol</li>
              <li>Adresinize teslimat ve/veya montaj</li>
            </ol>

            <h2 className="text-xl font-bold text-[#003132]">🧴 Kullandığımız Ürünler</h2>
            <ul className="list-disc list-inside">
              <li>Perde kumaşına uygun özel solüsyonlar</li>
              <li>Renk solmasını önleyen doğal içerikli deterjanlar</li>
              <li>Antibakteriyel temizlik ürünleri</li>
            </ul>

            <h2 className="text-xl font-bold text-[#003132]">✅ Neden Bizi Tercih Etmelisiniz?</h2>
            <ul className="list-disc list-inside">
              <li>Perdeye zarar vermeyen özel yıkama teknikleri</li>
              <li>Ücretsiz alım ve teslimat hizmeti</li>
              <li>Zebra ve stor perdeye özel temizlik garantisi</li>
              <li>Uygun fiyat – kaliteli hizmet dengesi</li>
              <li>Tecrübeli ekip ve müşteri odaklı yaklaşım</li>
            </ul>

            <p>
              Stor ve zebra perdelerinizin ömrünü uzatmak, ilk günkü temizliğine kavuşmasını sağlamak için bize ulaşın. Hijyenik, güvenilir ve profesyonel hizmeti kapınıza kadar getiriyoruz.
            </p>
          </div>

          {/* Mobilde sidebar içeriği */}
          <div className="block lg:hidden mt-10">
            <LeftSidebar />
          </div>
        </main>

        {/* Sağ Sidebar */}
        <div className="w-full">
          <RightSidebar />
        </div>
      </div>
    </>
  );
};

export default Zebra;
